module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tt-4252a958aa98bb3ef5f7755b8f0f8736.svg";